export default "__VITE_ASSET__KBO_TQ0N__"